import React from 'react';
import logo from '../logo/HDD_PrimaryLogo_White.png';
import '../css/custom.css'

function Header() {
    return (
      <nav className="navbar navbar-expand-lg bg-dark">
        <div className="container-fluid">
        <a href="./"><img src={logo} alt="HD White Logo" height="65" id="logo"></img></a>
          <button className="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar mx-auto">
              <a id="app-text" href="https://hd2pro.com/">Home</a>
              <a id="app-text" href="https://hd2pro.com/about/">About</a>
              <a id="app-text" href="https://hd2pro.com/direct-view-led/">Direct View LED</a>
              <a id="app-text" href="https://hd2pro.com/led-processors/">LED Processors</a>
              <div className="resources-dropdown">
                  <div id="app-text" className="resources-link" role="button">Resources</div>
                  <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="https://app.hd2pro.com">SBC dvLED Configurator</a></li>
                    <li><a className="dropdown-item" href="https://hd2pro.com/sbc-partnership/">SBC Partnership</a></li>
                  </ul>
                </div>
              </div>
            <div></div>
            <div>
              <a href="https://hd2pro.com/contact/" target="_blank" rel="noreferrer"><button className="btn btn-outline-primary float-right" id="top-button">Contact Us</button></a>
            </div>
          </div>
        </div>
      </nav>
    );
}

export default Header;
